export const MESSAGE_CONSTANT = {
  API_RESPONSE_NULL: 'API response data is null or undefined.',
  SOMETHING_WENT_WRONG: 'Something went wrong.',
  BAD_REQUEST: 'Bad request. Please check your input.',
  UNAUTHORIZED: 'Unauthorized! Redirecting to login.',
  FORBIDDEN: 'Forbidden! You don’t have permission to access this resource.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION_ERROR: 'Validation error. Please check your input.',
  INTERNAL_SERVER_ERROR: 'Internal server error. Please try again later.',
};
